import React from 'react';
import { MapPin, Phone, Mail, Linkedin, Instagram, Globe } from 'lucide-react';
import { Reveal, SectionHeading } from '../SectionHeading';
import { ContactForm } from '../ContactForm';
import { CONTACT } from '../../data/siteData';

const offices = [
  { title: 'Corporate Office', address: CONTACT.corporateOffice, q: 'Sector 3 Rohini, New Delhi 110085' },
  { title: 'Operating Office', address: CONTACT.operatingOffice, q: 'Bokaro Steel City, Jharkhand' },
];

export const ContactSection = () => (
  <section id="contact" data-testid="contact-section" className="py-20 md:py-32 bg-[#F8FAFC]">
    <div className="max-w-7xl mx-auto px-6 md:px-12">
      <SectionHeading
        label="Request a Call"
        title="Let's Plan Your Workforce Requirement"
        subtitle="Share your requirement and our solutions team will respond within one business day."
      />
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-10">
        <Reveal className="lg:col-span-7 bg-white border border-slate-200 rounded-xl p-7 md:p-10 shadow-sm">
          <ContactForm />
        </Reveal>

        <div className="lg:col-span-5 space-y-5">
          {offices.map((o, i) => (
            <Reveal key={o.title} delay={i * 0.1} className="bg-white border border-slate-200 rounded-xl overflow-hidden shadow-sm" data-testid={`office-card-${i}`}>
              <iframe
                title={`${o.title} map`}
                src={`https://maps.google.com/maps?q=${encodeURIComponent(o.q)}&z=13&output=embed`}
                className="w-full h-40 border-0"
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              />
              <div className="p-5 flex gap-3">
                <MapPin className="w-5 h-5 text-[#0066CC] shrink-0 mt-0.5" />
                <div>
                  <div className="text-xs font-bold uppercase tracking-[0.15em] text-slate-500">{o.title}</div>
                  <div className="text-sm text-[#0A192F] font-medium mt-1">{o.address}</div>
                </div>
              </div>
            </Reveal>
          ))}

          <Reveal delay={0.2} className="bg-[#0A192F] rounded-xl p-6 space-y-4">
            <a href={`tel:${CONTACT.phoneRaw}`} data-testid="contact-phone-link" className="flex items-center gap-3 text-slate-200 hover:text-white transition-colors">
              <Phone className="w-4 h-4 text-[#4DA3FF]" /> <span className="text-sm font-medium">{CONTACT.phone}</span>
            </a>
            <a href={`mailto:${CONTACT.email}`} data-testid="contact-email-link" className="flex items-center gap-3 text-slate-200 hover:text-white transition-colors">
              <Mail className="w-4 h-4 text-[#4DA3FF]" /> <span className="text-sm font-medium">{CONTACT.email}</span>
            </a>
            <a href={`mailto:${CONTACT.clientsEmail}`} className="flex items-center gap-3 text-slate-200 hover:text-white transition-colors">
              <Mail className="w-4 h-4 text-[#4DA3FF]" /> <span className="text-sm font-medium">{CONTACT.clientsEmail} <span className="text-slate-500">(Client Relations)</span></span>
            </a>
            <a href={CONTACT.website} target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 text-slate-200 hover:text-white transition-colors">
              <Globe className="w-4 h-4 text-[#4DA3FF]" /> <span className="text-sm font-medium">worklynx.co.in</span>
            </a>
            <div className="flex gap-3 pt-2 border-t border-white/10">
              <a href={CONTACT.linkedin} target="_blank" rel="noopener noreferrer" aria-label="LinkedIn" className="w-9 h-9 rounded-md bg-white/5 border border-white/10 flex items-center justify-center text-white hover:bg-[#0066CC] transition-colors">
                <Linkedin className="w-4 h-4" />
              </a>
              <a href={CONTACT.instagram} target="_blank" rel="noopener noreferrer" aria-label="Instagram" className="w-9 h-9 rounded-md bg-white/5 border border-white/10 flex items-center justify-center text-white hover:bg-[#0066CC] transition-colors">
                <Instagram className="w-4 h-4" />
              </a>
            </div>
          </Reveal>
        </div>
      </div>
    </div>
  </section>
);
